import React from "react";

const ITEMS = [
  "SMART CONTRIBUTIONS",
  "SIMPLE SETTLEMENTS",
  "QONTRI.IN",
  "UPI READY",
  "TRAVEL BUDDY",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#0F2C5A] text-[#F0EAFD] py-10 md:py-14 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display uppercase text-5xl md:text-7xl mx-8 flex items-center gap-8"
          >
            {t}
            <span className="inline-block w-3 h-3 rounded-full bg-[#3056F5]" />
          </span>
        ))}
      </div>
    </section>
  );
}
